import {
  CareerTableRoleFragmentFragment,
  CareerTrackRoleResponsibilityNode,
} from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import { currentUserVar, isAdminVar } from "@cache/cache";
import TextareaWysiwyg from "@components/wysiwyg/textarea-wysiwyg";

import AverageAssessmentAnswers from "./average-assessment-answers";
import NA from "./na";

const Responsibilities = ({
  responsibilities,
  careerRole,
  profile,
}: {
  responsibilities: Pick<CareerTrackRoleResponsibilityNode, "id" | "content">[];
  careerRole?: CareerTableRoleFragmentFragment | null;
  profile: BasicUser & { isInCurrentUserReportingTree: boolean };
}) => {
  if (!careerRole) {
    return <NA />;
  }

  const isAdmin = isAdminVar();
  const currentUser = currentUserVar();
  const canViewAverageAssessmentAnswers =
    profile.id === currentUser.id &&
    profile.isInCurrentUserReportingTree &&
    isAdmin;
  return (
    <div>
      {responsibilities.length === 0 ? (
        <NA />
      ) : (
        <ul className="">
          {responsibilities.map((responsibility) => (
            <li
              className="mb-2 flex items-start gap-2.5"
              key={responsibility.id}
            >
              <div className="bg-gray-300 rounded-full h-[5px] w-[5px] mt-[12px]" />
              <TextareaWysiwyg value={responsibility.content} />
            </li>
          ))}
        </ul>
      )}
      {canViewAverageAssessmentAnswers &&
        careerRole?.responsibilityAverageAssessmentAnswersByProgram && (
          <AverageAssessmentAnswers
            averageAssessmentAnswers={careerRole.responsibilityAverageAssessmentAnswersByProgram.filter(
              (p) => !!p,
            )}
            profileId={profile.id}
          />
        )}
    </div>
  );
};

export default Responsibilities;
